module.exports = __webpack_public_path__ + "static/media/diving_1366.bdaf81b2.jpg";